/*
 * 维护页。
 *
 * ## 它是全站唯一一处「别的都坏了也要显示得出来」
 *
 * 因此三条硬规则：
 *
 *   1. **背景与立绘一律走 `LOCAL_ASSETS`，不走服务端下发的 appearance。**
 *      维护窗口的典型用途就是迁数据，那时候库可能正在被改、正在不一致，
 *      而 `CharacterAppearance` 的图要经 `Asset` 拼 OSS 地址。
 *      走本地 `public/` 里的图，API 整个挂掉这一页也还在。
 *   2. **有一句写死的兜底文案。** `maintenanceNote` 是运营填的，
 *      常常是 null，而且取它就得先拿到服务端响应——这一页恰恰要在
 *      拿不到响应时也说得出话。
 *   3. **不引 chat.css。** 视觉照着 AVG 对话框（粉色药丸名牌 + 圆角框），
 *      只共享 `styles.css` 里的对话框高度变量。复用 `.theater` 那套会把这一页绑在
 *      一个 1600 行、按 5 行分页算过高度的样式表上，
 *      而那套里任何一次改动都可能让这一页在最需要它的时候排版崩掉。
 *
 * ## 为什么她还在说话
 *
 * 「灵境正在维护中」是系统状态，但由她说出来。这与 `offline-preview.ts`
 * 已经立的口径一致（灵境不稳 → 她使不出灵力），不是新发明。
 * 名牌只读产品默认角色的一项最小元数据 `characterDisplayName`，不依赖整套外观数据。
 */

import { useSession } from "../../state/session";
import { DreamBackdrop, StagePortrait } from "../../components/DreamStage";
import { LOCAL_ASSETS } from "../../services/offline-preview";
import "./maintenance.css";

/**
 * 运营没填 `maintenanceNote` 时说这句。
 *
 * ⚠ **不许删，也不许改成从服务端取。** 服务端那句
 * （`MAINTENANCE_FALLBACK_MESSAGE`）是给 503 响应体用的，
 * 拿不到响应的时候这一页仍然要有话说。两句重复是有意的。
 */
const FALLBACK_NOTE = "灵境正在维护中，请过段时间再来哦";

export function MaintenancePage() {
  const session = useSession();

  return (
    <div className="maintenance-page">
      <DreamBackdrop url={LOCAL_ASSETS.background} />

      <div className="maintenance-figure" aria-hidden>
        <StagePortrait state={{ kind: "ready", url: LOCAL_ASSETS.portrait, alt: "" }} />
      </div>

      <main className="maintenance-dock">
        <div className="maintenance-frame">
          <div className="maintenance-nameplate">
            {session.characterDisplayName ?? "梦灵"}
          </div>

          <div className="maintenance-box">
            <p className="maintenance-text">{session.maintenanceNote ?? FALLBACK_NOTE}</p>
          </div>
        </div>
      </main>
    </div>
  );
}
